
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elanlar/new",
      function () {
        return require("private-next-pages/elanlar/new/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elanlar/new"])
      });
    }
  